"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _core = require("@emotion/core");

var _reactGist = _interopRequireDefault(require("react-gist"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/** @jsx jsx */


var Gist = function Gist(props) {
  return (0, _core.jsx)("div", null, props.id ? (0, _core.jsx)("div", {
    style: {
      marginLeft: -8,
      marginRight: -8
    }
  }, (0, _core.jsx)(_reactGist["default"], props)) : (0, _core.jsx)("pre", null, "Enter a Gist ID"));
};

Gist.propertyControls = {
  isVoid: true,
  id: {
    type: 'string',
    title: 'Gist ID'
  }
};
var _default = Gist;
exports["default"] = _default;